import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import supabase from './supabaseClient'


export default function DealPage() {
  const { id } = useParams()
  const [deal, setDeal] = useState(null)

  useEffect(() => {
    const fetchDeal = async () => {
      const { data, error } = await supabase
        .from('deals')
        .select(`
          id,
          price,
          amount,
          trade_date,
          settlement_date,
          buyer_id,
          seller_id,
          rfq_requests (
            side,
            securities (
              name,
              isin,
              maturity_date,
              coupon_rate
            )
          )
        `)
        .eq('id', id)
        .single()

      if (!error) setDeal(data)
    }

    fetchDeal()
  }, [id])

  if (!deal) return <p>Загрузка...</p>

  const { rfq_requests: rfq, price, amount, trade_date, settlement_date } = deal
  const sec = rfq?.securities

  return (
    <div style={{ padding: '2rem' }}>
      <Link to="/">← Назад</Link>
      <h2>Сделка #{deal.id}</h2>

      <p>
        <strong>Инструмент:</strong> {sec?.name} (ISIN: {sec?.isin})<br />
        <strong>Сторона RFQ:</strong> {rfq?.side.toUpperCase()}<br />
        <strong>Купон:</strong> {sec?.coupon_rate}% до {sec?.maturity_date}<br />
        <strong>Объём:</strong> {amount}<br />
        <strong>Цена:</strong> {price}<br />
        <strong>Дата сделки:</strong> {trade_date?.split('T')[0]}<br />
        <strong>Расчёты:</strong> {settlement_date}<br />
      </p>
    </div>
  )
}
